module.exports = __webpack_public_path__ + "img/ybh.e00e1376.png";